import Phaser from 'phaser';
import { PowerUp, PowerUpConfig, WeightClass } from './PowerUp';

export interface BiomoneyPowerUpConfig extends PowerUpConfig {
  /** Amount of biomoney to give (default: 50) */
  amount?: number;
}

/**
 * BiomoneyPowerUp - Gives player biomoney/biomatter
 *
 * From C3: upBiomoney
 * Effects are handled by data-driven system (powerups-overrides.json)
 */
export class BiomoneyPowerUp extends PowerUp {
  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    texture: string = 'upBiomoney',
    config: BiomoneyPowerUpConfig = {}
  ) {
    const amount = config.amount ?? 50;

    super(scene, x, y, texture, {
      ...config,
      weight: config.weight ?? WeightClass.Light,
      bioMatter: amount,
    });
  }
}
